











import Vue from "vue";
import { DocumentField, DocumentFieldValue, FieldType } from "@infoland/iprova-api";
import Utils from "@/utils";
export default Vue.extend({
    name: "GeneralField",
    components: {},
    props: {
        field: { type: Object as () => DocumentField },
        values: { type: Array as () => DocumentFieldValue[] }
    },
    data: function () {
        return {};
    },
    methods: {
        isGuid(value: string): boolean {
            return Utils.isGuid(value);
        },
        isZenyaUser(fieldValue: DocumentFieldValue): boolean {
            return (
                (this.field.field_type.type === FieldType.user || (this.field.field_id === 35 && this.isGuid(fieldValue.id))) &&
                fieldValue.value &&
                fieldValue.value.length > 1
            );
        },
        isUser(fieldValue: DocumentFieldValue): boolean {
            return (
                (this.field.field_type.type === FieldType.user || (this.field.field_id === 35 && !this.isGuid(fieldValue.id))) &&
                fieldValue.value &&
                fieldValue.value.length > 1
            );
        }
    }
});
